<template lang="html">
  <v-card-text class="text-xs-left">
    <v-layout column>
      <span v-if="isEmpty(firmGroups)" class="my-2 grey--text ml-2">None</span>
      <v-layout
        v-else
        small
        align-center
        v-for="(group, i) in firmGroups"
        class="subheading my-2"
        :key="i"
      >
        <v-text-field
          v-if="selectedGroupId === group.id && groupNameEditing"
          v-model="groupNameToEdit"
          hide-details
          class="default-input"
          solo
          placeholder="Group Name"
        />
        <span v-else>{{ group.name }}</span>
        <v-tooltip
          bottom
          v-if="selectedGroupId === group.id && groupNameEditing"
        >
          <v-icon
            slot="activator"
            @click="saveGroupName()"
            class="ml-2 success--text"
            size="18"
            style="cursor: pointer"
            >check</v-icon
          >
          <span>Save</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <v-icon
            slot="activator"
            @click="editGroup(group)"
            class="ml-2 primary--text"
            size="18"
            style="cursor: pointer"
            >create</v-icon
          >
          <span>Edit Name</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="selectedGroupId === group.id && groupNameEditing"
        >
          <v-icon
            slot="activator"
            @click="cancelEditing()"
            class="ml-2 error--text"
            size="18"
            style="cursor: pointer"
            >clear</v-icon
          >
          <span>Cancel</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <v-icon
            slot="activator"
            @click="removeGroup(group.id, i)"
            class="ml-2 error--text"
            size="18"
            style="cursor: pointer"
            >delete_outline</v-icon
          >
          <span>Delete Group</span>
        </v-tooltip>
      </v-layout>
    </v-layout>
    <v-layout align-center>
      <v-text-field
        v-model="newGroupName"
        hide-details
        class="default-input"
        solo
        placeholder="New Group Name"
      />
      <v-btn
        class="primary text-none"
        @click="addGroup()"
        :disabled="isEmpty(newGroupName) || groupNameEditing"
      >
        Add Group
      </v-btn>
    </v-layout>
  </v-card-text>
</template>
<script>
import moment from 'moment';
import API from '@/api';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ManageGroups',
  data() {
    return {
      newGroupName: '',
      groupNameToEdit: '',
      groupNameEditing: false,
      selectedGroupId: null,
    };
  },
  computed: {
    ...mapGetters(['isAdvisor', 'currentFirm']),
    ...mapGetters({
      currentUser: 'user',
    }),
    firmGroups() {
      if (this.currentFirm) {
        return this.currentFirm.firm_groups;
      } else {
        return [];
      }
    },
  },
  methods: {
    moment,
    isEmpty,
    async addGroup() {
      if (this.currentFirm.firm_groups.includes(this.newGroupName)) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Group already exists',
        });
        return;
      }
      try {
        const response = await API.firm.addGroup(this.newGroupName);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Group created!',
          });
          this.$store.dispatch('setCurrentFirm');
        }
        this.newGroupName = '';
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the group. Please try again after refreshing the page.',
        });
      }
    },
    async saveGroupName() {
      if (this.currentFirm.firm_groups.includes(this.newGroupName)) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Group already exists',
        });
        return;
      }
      try {
        const response = await API.firm.updateGroup({
          groupId: this.selectedGroupId,
          newGroupName: this.groupNameToEdit,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Group saved!',
          });
          this.$store.dispatch('setCurrentFirm');
        }
        this.groupNameToEdit = '';
        this.selectedGroupId = null;
        this.groupNameEditing = false;
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem updating the group. Please try again after refreshing the page.',
        });
      }
    },
    editGroup(group) {
      this.selectedGroupId = group.id;
      this.groupNameToEdit = group.name;
      this.groupNameEditing = true;
    },
    cancelEditing() {
      this.selectedGroupId = null;
      this.groupNameToEdit = '';
      this.groupNameEditing = false;
    },
    async removeGroup(id, index) {
      try {
        const response = await API.firm.removeGroup(id);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Group deleted!',
          });
          this.currentFirm.firm_groups.splice(index, 1);
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem removing the group. Please try again after refreshing the page.',
        });
      }
    },
  },
};
</script>
